export default "__VITE_ASSET__D9wHQrhI__"